import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromEnum } from '../../app/api/responseUtil';

export enum ApiSelectedContext {
    TRANSPORT_ORDER = 'transport-order',
    TRANSPORT_CAPACITY_ORDER = 'transport-capacity-order',
    COMPOUND_VEHICLE = 'compound-vehicle',
    SERVICE_OPTION = 'service-option',
    SERVICE_ORDER = 'service-order',
    VDA_SERVICE_ORDER = 'vda-service-order',
    VDA_SERVICE_ORDER_RESPONSE = 'vda-service-order-response',
    VDA_TRANSPORT_CAPACITY_ORDER = 'vda-transport-capacity-order',
    VDA_TRANSPORT_CAPACITY_ORDER_RESPONSE = 'vda-transport-capacity-order-response',
    VDA_TRANSPORT_ORDER = 'vda-transport-order',
    VDA_TRANSPORT_ORDER_RESPONSE = 'vda-transport-order-response',
    VDA_TRANSPORT_STATUS_REPORTS = 'vda-transport-status-reports',
    VDA_COMPOUND_TRANSPORT_ORDER = 'vda-compound-transport-order',
}

export enum ApiEnvironment {
    PROD = 'prod',
    QA = 'qa',
}

const SelectedContextCodec = fromEnum<ApiSelectedContext>('ApiSelectedContext', ApiSelectedContext);

const EnvironmentCodec = fromEnum<ApiEnvironment>('ApiEnvironment', ApiEnvironment);

export const NaturalLanguageQueryCodec = t.intersection([
    t.type({
        query: NonEmptyString,
        selected_context: SelectedContextCodec,
        environment: EnvironmentCodec,
    }),
    t.partial({
        limit: t.number,
    }),
]);

export const DataItemCodec = t.record(t.string, t.any);

export const FinishedVehicleQueryResultCodec = t.type({
    query_id: NonEmptyString,
    limit_exceeded: t.boolean,
    items: t.array(DataItemCodec),
});

export type ApiNaturalLanguageQuery = t.TypeOf<typeof NaturalLanguageQueryCodec>;
export type ApiFinishedVehicleQueryResult = t.TypeOf<typeof FinishedVehicleQueryResultCodec>;
